import { ImpersonationStopReason } from '../impersonation.constants';

export interface ImpersonationState {
  isImpersonating: boolean;
  targetUserId: number | null;
  originalUserId: number | null;
  accessExpiresDateTime: string | null;
  accessScope: string[] | null;
  stopReason: ImpersonationStopReason | null;
  isConsultantImpersonation: boolean;
}

export const initialImpersonationState: ImpersonationState = {
  isImpersonating: false,
  targetUserId: null,
  originalUserId: null,
  accessExpiresDateTime: null,
  accessScope: null,
  stopReason: null,
  isConsultantImpersonation: false
};
